import { TRANSACTION_CONSTANTS } from '../constants/transactionConstants';

const initialState = {
  transactions: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTION_CONSTANTS.GET_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TRANSACTION_CONSTANTS.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.response || [],
        pagination: {
          totalPages: action.payload.pagination?.totalPages || 1,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
        },
        error: null,
      };
    case TRANSACTION_CONSTANTS.GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        transactions: [],
      };
    case TRANSACTION_CONSTANTS.RESET_TRANSACTION_STATE:
      return initialState;
    default:
      return state;
  }
};

export default transactionReducer;